import React from 'react';

interface MobilePrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}

export const MobilePrimaryButton: React.FC<MobilePrimaryButtonProps> = ({
  children,
  className = '',
  ...props
}) => (
  <button
    className={`h-full px-3 sm:px-6 flex py-2 text-sm rounded-md transition-colors bg-slate-800 hover:bg-slate-700 text-white ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const MobilePrimaryButtonLight: React.FC<MobilePrimaryButtonProps> = ({
  children,
  className = '',
  ...props
}) => (
  <button
    className={`h-full px-3 sm:px-6 flex py-2 text-sm rounded-md transition-colors bg-slate-200 hover:bg-slate-300 text-slate-800 ${className}`}
    {...props}
  >
    {children}
  </button>
);
